import { COMMUNITY_BASE_URL, COMMUNITY_USERS_BASE_URL } from 'Frontend/constants/endpoint'
import { IMembersSearchResults, IMembersSearchResultsItem } from '../models/members.model'
import { IUser } from '../models/user.model'
import { IAntiforgeryToken } from '../models/general.model'
import { getAntiforgeryToken } from './general.service'

export async function getUsers(
  pageIndex: number,
  query?: string,
  countyId?: number,
  municipalityId?: number,
  competenceAreaId?: number,
): Promise<IMembersSearchResults> {
  let response = await fetch(
    `${COMMUNITY_USERS_BASE_URL}?${query && query ? `query=${query}` : ''}&pageIndex=${pageIndex}${countyId && countyId ? `&countyId=${countyId}` : ''}${municipalityId && municipalityId ? `&municipalityId=${municipalityId}` : ''}${competenceAreaId && competenceAreaId ? `&competenceAreaId=${competenceAreaId}` : ''}`,
  )

  const jsonResults = await response.json()
  return <IMembersSearchResults>jsonResults
}

export async function getUsersToRemove(pageIndex: number, query?: string): Promise<IMembersSearchResults> {
  let response = await fetch(
    `${COMMUNITY_USERS_BASE_URL}?${query && query ? `query=${query}` : ''}&pageIndex=${pageIndex}&pageSize=${10}`,
  )

  const jsonResults = await response.json()
  return <IMembersSearchResults>jsonResults
}

export async function getModeratorsUsers(onlyModeratorAndAdmin: boolean): Promise<IMembersSearchResultsItem[]> {
  let response = await fetch(`${COMMUNITY_USERS_BASE_URL}?isModerator=${onlyModeratorAndAdmin}&getResultPaged=false`)

  const jsonResults = await response.json()
  return <IMembersSearchResultsItem[]>jsonResults
}

export async function getCurrentUser(): Promise<IUser> {
  let response = await fetch(`${COMMUNITY_USERS_BASE_URL}/currentUserId`)

  const jsonResults = await response.json()
  return <IUser>jsonResults
}

export async function deleteUser(userId: number): Promise<boolean> {
  const { csrfToken }: IAntiforgeryToken = await getAntiforgeryToken()

  let response = await fetch(`${COMMUNITY_USERS_BASE_URL}/${userId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': csrfToken,
    },
  })

  return response.ok
}

export async function getAllUsernames(): Promise<string[]> {
  let response = await fetch(`${COMMUNITY_BASE_URL}/accounts/usernames`)

  const jsonResults = await response.json()
  return <string[]>jsonResults
}

export async function changeUsername(token: string, currentUsername: string, newUsername: string): Promise<number> {
  const bodyForum = JSON.stringify({
    username: newUsername,
  })

  let response = await fetch(`${COMMUNITY_BASE_URL}/accounts/${currentUsername}/username`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token,
    },
    body: bodyForum,
  })

  return <number>response.status
}
